import { render, staticRenderFns } from "./ExpandingStat.vue?vue&type=template&id=73385868&scoped=true"
import script from "./ExpandingStat.vue?vue&type=script&lang=js"
export * from "./ExpandingStat.vue?vue&type=script&lang=js"
import style0 from "./ExpandingStat.vue?vue&type=style&index=0&id=73385868&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73385868",
  null
  
)

export default component.exports